var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 0.5C4.80488 0.5 2.20544 3.09944 2.20544 6.29456C2.20544 10.2598 7.39104 16.081 7.61182 16.3269C7.81919 16.5579 8.18126 16.5575 8.38826 16.3269C8.60904 16.081 13.7946 10.2598 13.7946 6.29456C13.7946 3.09944 11.1952 0.5 8.00004 0.5ZM8.00004 9.20997C6.39248 9.20997 5.08466 7.90212 5.08466 6.29456C5.08466 4.687 6.39251 3.37919 8.00004 3.37919C9.60757 3.37919 10.9154 4.68703 10.9154 6.29459C10.9154 7.90216 9.60757 9.20997 8.00004 9.20997Z",
    fill: "#FFB334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMark);
export default __webpack_public_path__ + "static/media/map-mark.85f3d0de9cb30bfefe1edaa8a0822d75.svg";
export { ForwardRef as ReactComponent };